import { Button, Paper, Typography } from '@mui/material';
import Image from '../../components/Image/Image';

import './CityMonitoringCTA.scss';

function CityMonitoringCTA({ className, placeholderMapImageUrl, handleGoToMonitoringPage }) {
  const classes = `city-monitoring-cta ${className ? className : ''}`
  return (
    <div className={classes}>
      <Paper
        className="content-container"
        elevation={2}>
        <Image src={placeholderMapImageUrl} />
        <Typography variant="p" component="p">
          Veja onde foram reportados focos em sua cidade
        </Typography>
        <Button onClick={handleGoToMonitoringPage}>Abrir mapa de monitoramento</Button>
      </Paper>
    </div>
  );
}

export default CityMonitoringCTA;
